{
  "addButtonLabel": "दवा जोड़ें",
  "dose": "खुराक",
  "dosePlaceholder": "e.g. 500mg or 1 tablet",
  "dropHere": "यहाँ ड्रॉप करें",
  "dropText": "<p>{{fileExtensions}} या {{fileExtension}} — अधिकतम {{mb}}MB तक</p>",
  "dropTitle": "<p><strong>एक फ़ाइल अपलोड करें</strong> या खींचकर यहाँ छोड़ें</p>",
  "frequency": "आवृत्ति",
  "manuallyText": "<strong>दवाएं मैन्युअली जोड़ें</strong><p>एक बार में एक दवा जोड़ें। नाम, खुराक और कितनी बार लेते हैं, यह शामिल करें।</p>",
  "medicationName": "दवा का नाम",
  "medicationPlaceholder": "<p><strong>कृपया अंग्रेज़ी में भरें।</strong><br/>उदाहरण के लिए: Metformin – 500mg morning and night</p>",
  "nextLabel": "$t(common:next): <b>इतिहास</b>",
  "saveButton": "दवा सहेजें",
  "select": {
    "as-needed": "ज़रूरत पड़ने पर",
    "once-daily": "दिन में एक बार",
    "three-time-daily": "दिन में तीन बार",
    "twice-daily": "दिन में दो बार"
  },
  "text": "<p>कृपया हमें उन दवाओं, इनहेलर्स, इंजेक्शनों या सप्लीमेंट्स के बारे में बताएं जो आप वर्तमान में ले रहे हैं।</p>\n<p>आप एक सूची अपलोड कर सकते हैं या उन्हें मैन्युअली जोड़ सकते हैं।</p>",
  "title": "दवाएँ",
  "uploadText": "<strong>एक प्रिस्क्रिप्शन या सूची अपलोड करें</strong>\n<p>यदि आपके पास अपने डॉक्टर या फ़ार्मेसी से मिली सूची है, तो एक फ़ोटो या PDF अपलोड करें।</p>"
}
